__turbopack_context__.v({
  "container": "ProductFooterForm-module-scss-module__223YjW__container",
  "dotSeparator": "ProductFooterForm-module-scss-module__223YjW__dotSeparator",
  "error": "ProductFooterForm-module-scss-module__223YjW__error",
  "footerActions": "ProductFooterForm-module-scss-module__223YjW__footerActions",
  "quantityChange": "ProductFooterForm-module-scss-module__223YjW__quantityChange",
});
